import { useNgSession } from "@sazka/ng/ng-session";
import { useAppInsights } from "@sazka/utils/logger/app-insights";

export const useWebAppInsights = () => {
    const { session } = useNgSession();

    const playerIdGetter = () => session.value?.PlayerID ?? null;

    useAppInsights().init(playerIdGetter);
};
